import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-data-sources-next",
  "use": "n-icon-data-sources-next-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-data-sources-next\">\n<path d=\"M11.6983 10.3334L8.2318 14.6932C7.87824 15.1175 7.93556 15.748 8.35984 16.1016C8.78412 16.4552 9.41468 16.3978 9.76825 15.9736L13.7682 10.9736C14.0773 10.6027 14.0773 10.064 13.7682 9.69318L9.76825 4.69318C9.41468 4.26891 8.78412 4.21158 8.35984 4.56515C7.93556 4.91871 7.87824 5.54928 8.2318 5.97355L11.6983 10.3334Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol